import { createSlice } from '@reduxjs/toolkit';
import { ProjectTemplate, ProjectTemplateStore } from '../types';
import { allocationSlice } from './allocation';
import { automationSlice } from './automations';
import { dynamicTemplateSlice } from './dynamic-template';
import { entitiesSlice } from './entities';
import { projectPhaseSlice } from './project-phase';
import { revenueRecognitionSlice } from './revenue-recognition';
import { spaceSlice } from './space';
import { sprintSlice } from './sprint';
import { tableSlice } from './table';
import { taskSlice } from './task';
import { templateSlice } from './template';
import { variablesSlice } from './variables';

const INITIAL_STATE: ProjectTemplateStore = {
  data: {
    new: {
      error: null,
      loading: true,
      spaceSetup: 'YET_TO_START',
      projectPhases: {},
      template: {} as ProjectTemplate,
      tasks: {},
      sprints: {},
      spaceList: {},
      dynamicConditions: {},
      placeholders: {},
      allocations: {},
      allocatedMembers: {
        users: [],
        teams: [],
      },
    },
  },
  activeRecord: undefined,
  activeId: 'new',
  projectToTemplate: false,
  activeSpaceId: null,
  activeSpaceTabId: null,
  recordForShowingVariablesSelect: undefined,
};

export const projectTemplateSlice = createSlice({
  initialState: INITIAL_STATE,
  name: '@@TEMPLATES/PROJECT',
  reducers: {
    ...templateSlice,
    ...projectPhaseSlice,
    ...taskSlice,
    ...sprintSlice,
    ...entitiesSlice,
    ...spaceSlice,
    ...tableSlice,
    ...dynamicTemplateSlice,
    ...allocationSlice,
    ...variablesSlice,
    ...automationSlice,
    ...revenueRecognitionSlice,
  },
});

export const {
  createProjectTemplateProjectPhase,
  createProjectTemplateTask,
  createProjectTemplateSprint,
  deleteProjectTemplateSprint,
  setProjectTemplateActiveRecord,
  createProjectTemplateSubTask,
  updateProjectTemplateProjectPhase,
  updateProjectTemplateProjectPhases,
  updateProjectTemplateTask,
  updateProjectTemplateTasks,
  updateProjectTemplateStartdayDuration,
  deleteProjectTemplateProjectPhase,
  deleteProjectTemplateTask,
  deleteProjectTemplateSubTask,
  createProjectTemplateSpace,
  updateProjectTemplateSpace,
  deleteProjectTemplateSpace,
  addProjectTemplateTaskDependency,
  addProjectTemplatePhaseDependency,
  setupSpacesOnProjectTemplate,
  setupSpacesOnProjectTemplateInProgress,
  setupSpacesOnProjectTemplateComplete,
  setupSpaceTabsOnSpaces,
  shiftStartDayOfProjectPhase,
  updateSpaceTabInSpaces,
  updateJiraMappingInTemplate,
  updateDynamicConditions,
  setDynamicConditions,
  makeDateShiftsForProjectPhases,
  makeDateShiftsForTasks,
  makeDateShiftsForSprints,
  bulkActions,
  setAllocatedMembers,
  stripAllocationSources,
  setConditionalVariables: setConditionalVariablesInProjectTemplate,
  removeConditionalVariables,
  updateAutomationById,
  updateAllAutomations,
  updateProjectPhaseTemplateEntityOrder,
  toggleEnabledStateForAutomationById,
  createAutomationForSource,
  updateProjectTemplateSprint,
  updateProjectTemplateSprints,
  updateRecognitionConfigAction,
  updateProjectTemplateTaskDependencies,
  updateProjectTemplatePhaseDependencies,
  setActiveTemplateId,
} = projectTemplateSlice.actions;
